export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            投稿爆料
          </h2>
          <p className="mt-2 text-sm text-foreground-500">你有料，我们帮你爆</p>
        </div>
        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-8">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary-50 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl md:text-3xl text-primary-500"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-base md:text-lg font-semibold text-foreground-900">
                欢迎投稿爆料，一起做最懂吃瓜的网友
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                如果你有第一手娱乐八卦、明星动态或网络热点线索，欢迎通过以下方式联系我们。51黑料吃瓜网承诺保护爆料人隐私，所有投稿将严格保密处理。你的爆料有可能成为明天的头条新闻！
              </p>
              <div className="mt-4 flex flex-wrap items-center justify-center md:justify-start gap-4 text-sm text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-mail-line text-primary-400"></i>
                  爆料邮箱：tips@51heiliaochigua.com
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-wechat-line text-primary-400"></i>
                  微信客服：heiliaochigua51
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}